import type { LANGUAGES } from '@crehana/ts-types';

/**
 * Per-organization override for the login screen headline (`FORM_TITLE`).
 *
 * There is no backend field for this copy: the pre-auth `organizationInfo` query
 * and the centralized branding payload both expose only images and palette
 * colors, so an organization that asks for its own wording can only get it from
 * here. Keyed by the org slug the page is resolved with (`/org/:slug/entrar/`).
 *
 * An org (or a language) that is not listed keeps the default `FORM_TITLE`.
 */
const LOGIN_TITLE_BY_ORG_SLUG: Record<
  string,
  Partial<Record<LANGUAGES, string>>
> = {
  // SWAT-956 / DCSM-14695 — Allianz asked for their own headline, written in
  // es-AR voseo ("Iniciá"), so it can't be derived from the org name either.
  allianz: {
    es: 'Iniciá sesión en Universidad Allianz',
  },
};

/**
 * Returns the organization's own login headline, or `undefined` when the org has
 * no override for the current language so the caller can fall back to
 * `t('FORM_TITLE')`.
 */
export const getOrgLoginTitle = (
  orgSlug: string | undefined,
  languageCode: LANGUAGES,
): string | undefined =>
  orgSlug ? LOGIN_TITLE_BY_ORG_SLUG[orgSlug]?.[languageCode] : undefined;
